import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';

declare var window: any;

@Injectable()
export class UrlService {
    constructor() {}

    public relativeImageUrl(value: string): string {
        const trim = (str, chars) =>
            str
                .split(chars)
                .filter(Boolean)
                .join(chars);
        if (value.match(/^(https?:)?\/\//)) {
            return value;
        } else {
            return `/${trim(value, '/')}`;
        }
    }

    public encodeURI(value: any): string {
        if (typeof value === 'string' || typeof value === 'number') {
            return Base64.encodeURI(`${value}`);
        } else {
            return Base64.encodeURI(JSON.stringify(value));
        }
    }

    public encode(value: any): string {
        if (typeof value === 'string' || typeof value === 'number') {
            return Base64.encode(`${value}`);
        } else {
            return Base64.encode(JSON.stringify(value));
        }
    }

    public decode(value: string): string {
        return Base64.decode(value);
    }

    public decodeBase64toJSON(value: string) {
        return this._decodeValue(value);
    }

    public getLocationHash(): string {
        const hash = /[^#]*$/.exec(window.location.href).toString();
        return hash;
    }

    public getQueryParam(key: string): any {
        const _urlString = window.location.href; // window.location.href
        try {
            const url = new URL(_urlString);
            return url.searchParams.get(key);
        } catch (e) {
            return this._getUrlParams()[key];
        }
    }

    public getQueryParamBase64(key: string): any {
        const c = this.getQueryParam(key);
        return this._decodeValue(c);
    }

    public isBase64(value: string) {
        try {
            Base64.decode(value);
            return true;
        } catch (e) {
            return false;
        }
    }

    public JSON(value: string): null | any {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }

    private _decodeValue(value: string): any {
        if (this.isBase64(value)) {
            value = this.decode(value);
            const p = this.JSON(value);
            if (p != null) {
                return p;
            }
        }
        return value;
    }

    private _stringToBase64(value: string): string {
        return window.btoa(unescape(encodeURIComponent(value)));
    }

    private _base64ToString(value: string): string {
        return decodeURIComponent(escape(window.atob(value)));
    }

    private _base64ToUtf8(value: string): string {
        value = value.replace(/\s/g, '');
        return decodeURIComponent(escape(window.atob(value)));
    }

    private _getUrlParams() {
        let match;
        const pl = /\+/g, // Regex for replacing addition symbol with a space
            search = /([^&=]+)=?([^&]*)/g,
            decode = (s) => {
                return decodeURIComponent(s.replace(pl, ' '));
            },
            query = window.location.search.substring(1);

        let urlParams = {};
        while ((match = search.exec(query))) {
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    }

    public getURLParams (url = window.location): any {
        // Create a params object
        let params = {};
    
        new URL(url).searchParams.forEach(function (val, key) {
            if (params[key] !== undefined) {
                if (!Array.isArray(params[key])) {
                    params[key] = [params[key]];
                }
                params[key].push(val);
            } else {
                params[key] = val;
            }
        });
    
        return params;    
    }
}
